import { useState, useEffect } from 'react'

export const useThemeDetection = () => {
  const [isClearTheme, setIsClearTheme] = useState(false)

  useEffect(() => {
    // Check if the current theme is the clear (white) theme
    const checkTheme = () => {
      const bodyClasses = document.body.className
      setIsClearTheme(bodyClasses.includes('theme-clear'))
    }

    checkTheme()

    // Watch for theme changes
    const observer = new MutationObserver(checkTheme)
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    })

    return () => observer.disconnect()
  }, [])

  return { isClearTheme }
}